<script setup>
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { PrimaryButton } from "@Components/Button";
import { FormCard, FormSwitch } from "@Components/Form";
import UpdateAutomaticSourcesFormPart from "./UpdateAutomaticSourcesFormPart.vue";
import UpdateAutomaticLengthFormPart from "./UpdateAutomaticLengthFormPart.vue";
import UpdateAutomaticPositionsFormPart from "./UpdateAutomaticPositionsFormPart.vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();

const form = useForm(props.settings);

const sources = [
    {
        key: "parent",
        name: __("Page parente"),
        description: __("Ajoute le lien de la page mère."),
    },
    {
        key: "children",
        name: __("Pages enfants"),
        description: __("Ajoute les liens des pages enfants."),
    },
    {
        key: "sisters",
        name: __("Pages soeurs"),
        description: __("Ajoute les liens des pages soeurs."),
    },
];

const submit = () => {
    if (form.processing) return;
    form.post("linking_automatic_pages_update_settings");
};
</script>

<template>
    <FormCard :title="__('Related Content pour les pages')">
        <form @submit.prevent="submit">
            <div class="space-y-6">
                <FormSwitch v-model="form.enabled">{{ __("Activer l'affichage des pages similaires") }}</FormSwitch>

                <UpdateAutomaticSourcesFormPart v-model="form" :sources="sources" />

                <UpdateAutomaticLengthFormPart v-model="form" />

                <UpdateAutomaticPositionsFormPart v-model="form" />
            </div>

            <div class="flex justify-end items-center mt-6">
                <ActionMessage :on="form.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>

                <PrimaryButton :processing="form.processing"> {{ __("Sauvegarder") }} </PrimaryButton>
            </div>
        </form>
    </FormCard>
</template>
